export default function SendIcon({ className = "", onClick = null }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
      role="img"
      aria-label="Send"
    >
      <path
        d="M368.72,200.57l-105.6-105.6c-7.13-7.13-18.69-7.13-25.82,0l-105.96,105.96c-9.49,9.49-9.6,24.8-.35,34.43,9.56,9.95,25.73,9.76,35.49,0l59.02-59.02v202.04c0,13.53,10.97,24.5,24.5,24.5s24.5-10.97,24.5-24.5v-202.47l59.8,59.8c9.49,9.49,24.8,9.6,34.43.35,9.95-9.56,9.76-25.73,0-35.49Z"
        fill="currentColor"
      />
    </svg>
  );
}
